import React from 'react';

import Input, {InputAdornment, InputLabel} from 'material-ui/Input';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';
import { Select, TextField, withValidatedInputs, Validations } from '../../../../components/forms';
import Button from 'material-ui/Button';

import {Add} from 'material-ui-icons';

import Grid from 'material-ui/Grid';
import Divider from 'material-ui/Divider';
import { getSettings } from 'utils/client';

import axios from 'axios';
import tsl from './../../../tsl';

class AircraftsOffer extends React.Component {

    state = {
        aircrafts: [],
        currencies: [],
        validation: [],
    }

    componentWillMount() {
        axios.get('/currency').then((res) => {
            this.setState({
                currencies: res.data
            });
        });

        axios.get('/api/operator/aircraft/models').then((res) => {
            this.setState({
                aircrafts: res.data.data
            })
        });
    }

    propagateOffersChanges = (newOffers) => {
        this.props.onChange(newOffers);
    }

    handleRelationChange = (index) => (e) => {
        let newOffers = this.props.offers;
        
        if (!newOffers[index]) {
            newOffers[index] = {};
        }

        newOffers[index][e.target.name] = {id: e.target.value};

        this.propagateOffersChanges(newOffers);
    }

    handleChange = (index) => (e) => {
        let newOffers = this.props.offers;
        
        if (!newOffers[index]) {
            newOffers[index] = {};
        }

        newOffers[index][e.target.name] = e.target.value;

        this.propagateOffersChanges(newOffers);
    }

    deleteOffer = (index) => (e) => {
        let newOffers = []

        for (let i in this.props.offers) {
            if (i != index) {
                newOffers.push(this.props.offers[i]);
            }
        } 

        this.propagateOffersChanges(newOffers);
    }

    addNew = () => {
        let newOffers = this.props.offers;
        
        newOffers.push({
            currency_code: getSettings('currency_code') || this.state.currencies[0].code
        });

        this.propagateOffersChanges(newOffers);
    }

    render() {
        const {aircrafts} = this.state;
        const {currencies} = this.state;

        return (
        <div className="w-100">

        {this.props.offers.map((offer, offerIndex) => {
            // capacity validation
                let unusedSeats = 0, selectedAircraft = null;
                if (offer.aircraft_model) {
                    selectedAircraft = aircrafts.find( a => a.id == offer.aircraft_model.id);

                    if (offer.passengers_capacity && selectedAircraft) {
                        unusedSeats = selectedAircraft.passengers_capacity - offer.passengers_capacity;
                    }
                }

            // min. passengers validation
            const minPassengersValid = offer.passengers_min
                ? parseInt(offer.passengers_capacity) >= parseInt(offer.passengers_min)
                : true; 

            return (
            <Grid container spacing={16} key={offerIndex}>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="language">{tsl('offers.edit.aircraft.model')}</InputLabel>
                        <Select
                            formActions={this.props.formActions}
                            required
                            name="aircraft_model"
                            value={offer.aircraft_model ? offer.aircraft_model.id : 0}
                            onChange={this.handleRelationChange(offerIndex)}
                        >
                            <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                            {aircrafts.map((aircraft) => {
                                return (<MenuItem key={aircraft.id} value={aircraft.id}>{aircraft.name}</MenuItem>);
                            })}
                        </Select>
                    </FormControl>   
                    <br /><br />          

                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger,
                            (value) => unusedSeats < 0 ? tsl('offers.edit.exceeds_capacity') : true
                        ]}
                        fullWidth
                        name="passengers_capacity"
                        value={offer.passengers_capacity || ''}
                        onChange={this.handleChange(offerIndex)}
                        label={tsl('offers.edit.available_seats') + (selectedAircraft ? " (max. "+selectedAircraft.passengers_capacity+")" : '')}
                        InputProps={{endAdornment: 
                                <InputAdornment position="end">{tsl('offers.edit.persons_suffix')}</InputAdornment>}}
                        margin="normal"
                        className="mt-1"
                    />
                    <TextField
                        formActions={this.props.formActions}
                        required
                        validations={[
                            Validations.isInteger,
                            (value) => minPassengersValid ? true : tsl('offers.edit.exceeds_available_seats')
                        ]}
                        fullWidth
                        name="passengers_min"
                        value={offer.passengers_min || ''}
                        onChange={this.handleChange(offerIndex)}
                        label={tsl('offers.edit.minimum_to_fly')}
                        InputProps={{endAdornment: 
                                <InputAdornment position="end">{tsl('offers.edit.persons_suffix')}</InputAdornment>}}
                        margin="normal"
                        className="mt-1"
                    />
                </Grid>
                
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="language">{tsl('offers.edit.currency')}</InputLabel>
                        <Select
                            formActions={this.props.formActions}
                            required
                            name="currency_code"
                            value={offer.currency_code || 0}
                            onChange={this.handleChange(offerIndex)}
                        >
                            <MenuItem value={0}>{'- '+tsl('offers.edit.select_one')+' -'}</MenuItem>
                            {currencies.map((curr) => {
                                return (<MenuItem key={curr.id} value={curr.code}>{curr.code}</MenuItem>);
                            })}
                        </Select>
                    </FormControl>
                    <br /><br />

                    <TextField
                        formActions={this.props.formActions}
                        validations={[
                            Validations.isNumeric
                        ]}
                        fullWidth
                        name="price_exclusive"
                        value={offer.price_exclusive || ''}
                        onChange={this.handleChange(offerIndex)}
                        label={offer.price_exclusive ? tsl('offers.edit.exclusive_price') :  tsl('offers.edit.type_price_to_enable_exclusive')}
                        helperText={offer.price_exclusive ? tsl('offers.edit.leave_empty_to_disable_exclusive') : " "}
                        InputProps={{startAdornment: 
                                <InputAdornment position="start">{offer.currency_code || '-'}</InputAdornment>}}
                        margin="normal"
                        className="mt-1"
                    />

                    <TextField
                        formActions={this.props.formActions}
                        validations={[
                            Validations.isNumeric
                        ]}
                        fullWidth
                        name="price_passenger"
                        value={offer.price_passenger || ''}
                        onChange={this.handleChange(offerIndex)}
                        label={offer.price_passenger ? tsl('offers.edit.per_seat_price') : tsl('offers.edit.type_price_to_enable_per_seat')}
                        helperText={offer.price_passenger ? tsl('offers.edit.leave_empty_to_disable_per_seat') : " "}
                        InputProps={{startAdornment: 
                                <InputAdornment position="start">{offer.currency_code || '-'}</InputAdornment>}}
                        margin="normal"
                        className="mt-1"
                    />

                </Grid>

                <Grid item xs={12} sm={12} style={{textAlign: 'left'}}>
                    <Button onClick={this.deleteOffer(offerIndex)} style={{color: "red"}}>{tsl('offers.edit.remove')}</Button>
                    <br /><br />
                </Grid>
            </Grid>);
        })}

        <div className="w-100" style={{textAlign: 'right'}}>
            <Button fab raised color="accent" className="text-white jr-btn-fab-sm"
                aria-label="add"
                onClick={this.addNew}
            >
                <Add />
            </Button>
        </div>
        </div>);
    }
};

export default AircraftsOffer;



// WEBPACK FOOTER //
// ./app/used/offers/routes/EditationAircraftOffers.js